"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListInput = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const multi_list_chooser_1 = require("../../modules/multi.list.chooser/multi.list.chooser");
const multi_list_chooser_style_1 = require("../../modules/multi.list.chooser/multi.list.chooser.style");
const nested_list_chooser_state_1 = require("../../modules/multi.list.chooser/nested.list.chooser.state");
const select_list_chooser_state_1 = require("../../modules/multi.list.chooser/select.list.chooser.state");
const services_1 = require("../../services");
const render_service_1 = require("../../services/render.service");
const icon_1 = require("../icon");
const icons_1 = require("../icon/icons");
const modal_service_1 = require("../modal/modal.service");
const theme_1 = require("../theme");
const nested_list_input_style_1 = require("./nested.list.input.style");
(0, theme_1.addStyles)(nested_list_input_style_1.Style);
exports.MultiListInput = {
    view(state) {
        let color = null;
        if (
        // If we have the correct token
        services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) &&
            // And the state is one of the correct types
            (state instanceof select_list_chooser_state_1.SelectListChooserState || state instanceof nested_list_chooser_state_1.NestedListChooserState) &&
            // And the state's field is the one marked as the color field
            state.field.collection.schema.metadata.mapColorFieldId === state.field.schema.id) {
            color = state.field.color;
        }
        const children = [(0, render_service_1.m)('span', { className: nested_list_input_style_1.CSS.label }, state.displayValue)];
        if (color) {
            children.push((0, render_service_1.m)('div', { className: nested_list_input_style_1.CSS.colorIndicator, style: { backgroundColor: color } }));
        }
        children.push(icon_1.Icon.view(icons_1.MaterialIcon.FILTER_NONE, { className: nested_list_input_style_1.CSS.edit }));
        return (0, render_service_1.m)('div', { className: nested_list_input_style_1.CSS.container }, [
            (0, render_service_1.m)('button', {
                className: `${nested_list_input_style_1.CSS.button} mdl-button`,
                onclick: (e) => exports.MultiListInput.viewModal(e.target, state),
            }, children),
        ]);
    },
    viewModal(element, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (modal_service_1.ModalService.isOpen) {
                return;
            }
            state.setFocused(true);
            const oldValue = state.value != null ? state.value.slice() : null;
            const result = yield modal_service_1.ModalService.open({
                title: multi_list_chooser_1.MultiListChooserTitle.view(state),
                content: () => multi_list_chooser_1.MultiListChooserContent.view(state),
                className: multi_list_chooser_style_1.CSS.modal,
                hasCancel: true,
            });
            if (result.ok && state.value == null) {
                // Assign default value
                state.selectDefaultValue();
            }
            else if (!result.ok) {
                state.setValue(oldValue);
            }
            state.setFocused(false);
            element.focus();
        });
    },
};
//# sourceMappingURL=multi.list.input.js.map